function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Page 1");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sign-up",
  transform: "translate(-566.000000, -377.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(501.000000, 243.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65,143 L66.7767858,143 L66.7767858,152 L70.3125006,152 L70.3125006,143 L72.6874994,143 L73,139.896874 L70.3303566,139.896874 L70.3303566,138.35 C70.3303566,138.112498 70.3407726,137.929688 70.3616069,137.801562 C70.3824411,137.673438 70.4300594,137.548438 70.504464,137.426562 C70.5788686,137.304687 70.6964274,137.220313 70.8571429,137.173438 C71.0178583,137.126562 71.2321417,137.103126 71.5,137.103126 L72.982144,137.103126 L72.982144,134 L70.6160709,134 C69.2470171,134 68.2648846,134.340622 67.6696434,135.021874 C67.0744018,135.703129 66.7767858,136.706242 66.7767858,138.031251 L66.7767858,139.896874 L65,139.896874 L65,143 Z",
  id: "Page-1"
})))));

var SvgFacebookLogo = function SvgFacebookLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "18px",
    viewBox: "0 0 8 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-logo.0df36674.svg";
export { ForwardRef as ReactComponent };